import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ZoneGroupChart = ({ chartData, title = "Zones & Groups Overview" }) => {
  if (!chartData || chartData.length === 0) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        color: '#666',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        Loading zones and groups data...
      </div>
    );
  }

  const data = {
    labels: chartData.map(item => item.name),
    datasets: [
      {
        label: 'Count',
        data: chartData.map(item => item.count),
        backgroundColor: chartData.map(item => item.color) || ['#FF6384', '#36A2EB'],
        borderColor: chartData.map(item => item.color) || ['#FF6384', '#36A2EB'],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `${context.label}: ${context.parsed.y}`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
        grid: {
          color: 'rgba(0,0,0,0.1)',
        }
      },
      x: {
        grid: {
          display: false,
        }
      }
    },
  };

  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      marginBottom: '20px'
    }}>
      <h3 style={{ 
        marginTop: 0, 
        marginBottom: 15, 
        color: '#1976d2', 
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center'
      }}>
        {title}
      </h3>
      <div style={{ height: '300px', position: 'relative' }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ZoneGroupChart;
